import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { OperationService } from './operation.service';
import { OperationResolver } from './operation.resolver';
import { OperationListComponent } from './operation-list.component';
import { OperationEditComponent } from './operation-edit.component';
import { OperationFilterDialogComponent } from './operation-filter-dialog.component';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RouterModule
  ],
  declarations: [
    OperationListComponent,
    OperationEditComponent,
    OperationFilterDialogComponent
  ],
  providers: [
    OperationService,
    OperationResolver,
  ],
  bootstrap: [
    OperationFilterDialogComponent,
  ]
})
export class OperationModule { }
